export default __webpack_public_path__ + "static/media/welcome-female.6f054c2b.png";